import React from "react";
import CustomSpan from "../../components/CustomSpan";
import { formatDate } from "../../utils/datetime-utils";
import {
  getInspectionResutlBackground,
  getInspectionResutlColor,
  getJudgmentResultSymbol
} from "../../utils/display-utils";
import { useSelector } from "react-redux";
import Table from "../../components/table/Table";
import RightArrowIcon from "../../assets/icons/right-arrow-icon.svg";
import { Button } from "../buttons";
import { JUDGMENT } from "../../constants/routes";
import { useNavigate } from "react-router-dom";
import CustomImg from "../../components/CustomImg";

function JudgmentStatus({ judgmentStatus, inspectionId, workflowId }) {
  const resultSymbolSetting = useSelector(
    (s) => s.app_settings.inspection_display.inspection_result_symbol
  );
  const handleNavigate = () => {
    navigate(`${JUDGMENT}?inspection=${inspectionId}&workflow=${workflowId}`);
  };
  const navigate = useNavigate();

  const maxWidth = judgmentStatus?.judgments?.length * 160 + 1;

  return (
    judgmentStatus && (
      <div className="relative overflow-x-auto">
        <Table
          className="no-drop-shadow-table border border-tenken-gray-400"
          striped
        >
          <Table.Head>
            <Table.HeadCell
              colspan={judgmentStatus.judgments.length}
              style={{ maxWidth: `${maxWidth}px` }}
              className="text-center !rounded-none normal-case lg:py-2.5 py-[10px] font-medium truncate"
            >
              <CustomSpan
                text={judgmentStatus.workflow.name}
                title={judgmentStatus.workflow.name}
              />
            </Table.HeadCell>
          </Table.Head>
          <Table.Head className="!rounded-none whitespace-nowrap">
            {judgmentStatus.judgments.map((item, index) => (
              <Table.HeadCell
                key={index}
                className="border border-tenken-gray-400 text-center lg:py-2.5 py-[10px] font-medium max-w-[160px] truncate"
              >
                <CustomSpan
                  text={item.incharge_name}
                  title={item.incharge_name}
                />
              </Table.HeadCell>
            ))}
          </Table.Head>
          <Table.Body className="devide-y">
            <Table.Row>
              {judgmentStatus.judgments.map((item, index) => (
                <Table.Cell
                  className="border border-tenken-gray-400 pt-2.5 pb-2.5 !px-0 lg:py-0 lg:!h-[222px] !h-[214px] py-0 w-[160px]"
                  key={index}
                >
                  <div className="flex p-[10px_20px_20px_20px] flex-col items-center justify-between h-[180px]">
                    <div>
                      {item.result === 1 && (
                        <CustomImg src={RightArrowIcon} alt="judged" />
                      )}
                    </div>
                    {!item.can_rejudgment && item.result >= 0 && (
                      <p className="block h-[40px] text-center leading-[40px]">
                        <span className="inline-block px-auto py-1 w-10" style={{
                          color: getInspectionResutlColor(
                            item?.result,
                            resultSymbolSetting
                          ),
                          background: getInspectionResutlBackground(
                            item?.result,
                            resultSymbolSetting
                          ),
                        }}>
                          {getJudgmentResultSymbol(
                            item.result,
                            resultSymbolSetting
                          )}
                        </span>
                        <span className="ml-1">
                          {item.result === 1 ? "承認" : "差し戻し"}
                        </span>
                      </p>
                    )}

                    {item.can_rejudgment && (
                      <Button
                        color="yellow"
                        className="w-[112px]"
                        onClick={() => handleNavigate()}
                      >
                        再判定
                      </Button>
                    )}
                    {item.can_judgment && (
                      <Button
                        color="red"
                        className="w-[112px]"
                        onClick={() => handleNavigate()}
                      >
                        判定
                      </Button>
                    )}
                  </div>
                  <CustomSpan
                    text={
                      item?.judgment_datetime
                        ? formatDate(item.judgment_datetime)
                        : ""
                    }
                    className="block text-center h-[20px]"
                  ></CustomSpan>
                </Table.Cell>
              ))}
            </Table.Row>
          </Table.Body>
        </Table>
      </div>
    )
  );
}

export default JudgmentStatus;
